
import { SpecialtiesProps } from './types';

export const Specialties = ({ specialties }: SpecialtiesProps) => {
  if (!specialties || specialties.length === 0) return null;
  
  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {specialties.slice(0, 3).map((specialty, index) => (
        <span 
          key={index} 
          className="text-xs px-2 py-1 rounded-full bg-primary text-white"
        >
          {specialty}
        </span>
      ))}
      {specialties.length > 3 && (
        <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600">
          +{specialties.length - 3} more
        </span>
      )}
    </div>
  );
};
